import React from "react";
import { OfferData } from "../../../MockData";

const Offer = () => {
  return (
    <div className="relative pb-20 flax">
      <div className="absolute inset-0 bg-primary-200 top-[20%] z-0" />

      <div className="relative z-10 section-container bg-white shadow-lg md:p-20 p-5 border border-primary-200">
        <div className="grid md:grid-cols-3 gap-5 items-center">
          {/* Column 1 */}
          <div className="flax-col gap-8">
            <div className="title-space">
            <div className="section-title">
              What We Offer
            </div>
            <div>
            <div className="title-description">
              Bringing a creative <br /> way of packaging.
            </div>
            <hr className="my-4 w-12 border-primary-200" />
            </div>
            </div>
              
            {OfferData.slice(0, 1).map((service, index) => (
              <div key={index} className="flex gap-4 md:mt-[4rem]">
                <div>
                  <span className="offer-icon">
                    {service.icon}
                  </span>
                </div>

                <div className="title-space">
                  <div className="font-semibold text-text_color-200 text-xl">
                    {service.title}
                  </div>
                  <p className="text-sm text-text_color-100">{service.desc}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Column 2 */}
          <div className="flex flex-col md:gap-28 gap-8">
            {OfferData.slice(1, 3).map((service, index) => (
              <div key={index} className="flex gap-4">
                 <div>
                  <span className="offer-icon">
                    {service.icon}
                  </span>
                </div>

                <div className="title-space">
                  <div className="font-semibold text-xl text-text_color-200">
                    {service.title}
                  </div>
                  <div className="text-sm text-text_color-100">{service.desc}</div>
                </div>
              </div>
            ))}
          </div>

          {/* Column 3 */}
          <div className="flex flex-col md:gap-28 gap-8">
            {OfferData.slice(3).map((service, index) => (
              <div key={index} className="flex gap-4">
                   <div>
                  <span className="offer-icon">
                    {service.icon}
                  </span>
                </div>
                <div className="title-space">
                  <div className="font-semibold text-xl text-text_color-200">
                    {service.title}
                  </div>
                  <div className="text-sm text-text_color-100">{service.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Offer;
